import React, { useCallback, useEffect, useRef, useState } from 'react';
import TController from './components/view/TController';
import { IData } from './helpers/interface';
import { initialState } from './helpers/initialState';
import lodash from 'lodash';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Box from '@mui/material/Box/Box';
import ChildHeader from '../../components/ui/ChildHeader';
import {
  CustomButton,
  SaveButton,
  SubmitButton,
} from '../../components/common/button/CustomButtons';
import { useAuth } from '../../services/auth/AuthProvider';
import { useQuery } from '../../hooks/UseQuery';
import { processes } from './helpers/initialState';
// import PartTable from './components/view/PartTable';
// import ModalCustom from '../../components/common/Modal';
import useConfirm from '../../components/common/useConfirm';
import ModalCustom from '../../components/common/Modal';
import { GoSync } from 'react-icons/go';
import { Loader } from '../../components/common/Loader';
import { SearchFilterContainer } from '../../assets/styles/layout/searchFilter.styled';
import { SearchBar } from '../../components/common';
import FilterBy from '../../components/common/FilterBy';

const View = () => {
  const [moduleData, setModuleData] = useState<any>({
    list: [],
  });
  const [deptmoduleData, setDeptModuleData] = useState<any>({
    list: [],
  });
  const [render, setRender] = useState(false);
  const navigate = useNavigate();
  const { state } = useAuth();
  const { id } = useParams();
  const annual_month = useQuery('annual_date') || '';
  const isView = useQuery('isView') === 'true' ? true : false;
  const indexRef = useRef(0);
  const [isSync, setIsSync] = useState(false);
  const [isdept, setIsdept] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [filterDepartment, setFilterDepartment] = useState([]);
  const department = useQuery('department') || '';

  const [DialogDeleteRow, confirmDeleteRow] = useConfirm(
    'DELETE',
    'Are you sure you want to delete Row?',
  );

  const [DialogSubmit, confirmSubmit] = useConfirm(
    'Submit',
    'Are you sure you want to save this document?',
  );

  const [Sync, confirmSync] = useConfirm(
    'SYNC',
    'Are you sure you want to sync? Save any changes before sync!',
  );

  useEffect(() => {
    axios
      .get('/api/department/department/departmentForAutoComplete')
      .then((res) => {
        if (res?.data) {
          const formattedData = res.data.map((department: any) => ({
            name: department.department_name,
            value: department.department_name,
          }));
          setFilterDepartment(formattedData);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // useEffect(() => {}, [department]);

  const handleHolidayCheckBox = useCallback(
    (index: number) => {
      const ans = window.confirm('Are you sure!!!');
      if (!ans) return;
      const newModuleData = { ...moduleData };
      newModuleData.holidays[index] =
        newModuleData.holidays[index] === 'H'
          ? (newModuleData.holidays[index] = '')
          : (newModuleData.holidays[index] = 'H');
      newModuleData?.list?.forEach(
        (item: any, iIdx: number) =>
          (newModuleData.list[iIdx].attendance[index] =
            newModuleData.holidays[index]),
      );
      setModuleData(newModuleData);
    },

    [moduleData],
  );

  useEffect(() => {
    if (annual_month) {
      setIsLoading(true);
      axios
        .get(
          `/api/attendanceResisterRoute/${annual_month}?department=${department}`,
        )
        .then((res) => {
          setModuleData(res.data);
          setDeptModuleData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    }
  }, [id, isSync]);

  const handleSumbit = async () => {
    const ans = await confirmSubmit();
    if (!ans) return;
    if (moduleData._id) {
      setIsLoading(true);
      await axios
        .put(`/api/attendanceResisterRoute/${moduleData._id}`, moduleData)
        .then((res) => {
          if (res.data.status === 'success') {
            alert('Updated Successfully');
            setIsLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    }
  };

  const handelSync = async () => {
    const ans = await confirmSync();
    if (!ans) return;
    setIsLoading(true);
    axios
      .get(
        `/api/attendanceResisterRoute/handleSync/${moduleData._id}/?annual_month=${annual_month}`,
      )
      .then((res) => {
        window.alert('Sync Succesfully');
        setIsSync((prev) => !prev);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  const handelDeleteRows = async () => {
    const ans = await confirmDeleteRow();
    if (!ans) return;
  };
  return (
    <>
      <Box>
        <Loader loader={isLoading} />
        <ChildHeader text="Attendance Resister">
          {!isView && (
            <>
              <CustomButton
                sx={{
                  backgroundColor: '#228be6',
                  color: '#e7f5ff',
                  mr: 2,
                }}
                icon={<GoSync />}
                size="large"
                disabled={!moduleData._id}
                onClick={() => handelSync()}
              >
                Sync Employee
              </CustomButton>
              <SubmitButton label="Submit" onClick={() => handleSumbit()} />
              <FilterBy
                sx={{
                  width: 300,
                  backgroundColor: 'white',
                }}
                name="department"
                label="Filter By Department"
                options={filterDepartment}
              />
            </>
          )}
        </ChildHeader>
      </Box>

      <TController
        {...{
          moduleData,
          isView,
          handleHolidayCheckBox,
          handelDeleteRows,
          department,
        }}
      />

      <DialogDeleteRow isSubmitContent={false} />
      <Sync isSubmitContent={false} />
      <DialogSubmit />
    </>
  );
};

export default View;
